import { NgModule } from '@angular/core';
import { ReportStandaloneModule } from '@ndk/ng-reports/component/ndd-ng-reports-standalone';
import { NDDIntlService } from 'ndd-ng-intl';

import { CustomIntlService } from '@shared/overrides/custom-intl.service';

@NgModule({
    imports: [ReportStandaloneModule],
    exports: [],
    declarations: [],
    providers: [{
        provide: NDDIntlService,
        useClass: CustomIntlService,
    }],
})
export class ReportsStandaloneModule { }
